/* beautiful-react-hooks version: 0.27.2 */
import useGlobalEvent$1 from './useGlobalEvent.js';

var useWindowResize = function useWindowResize(handler) {
  return useGlobalEvent$1('resize', null, handler);
};

export default useWindowResize;
